import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.section-container {
    overflow: hidden;
}
.current-performance {
  font-size: 14px;
  color: #111111;
  padding-bottom: calc(24px / 2);
    font-weight: bold;
}
.money-market-footer {
  font-size: 14px;
  color: #111111;
  padding-bottom: calc(24px / 2);
    font-weight: bold;
}
.performance-shown {
  font-size: 14px;
  color: #111111;
  padding-bottom: calc(24px / 2);
    font-weight: bold;
}
.redemption-nomore {
  font-size: 14px;
  color: #111111;
  padding-bottom: calc(24px / 2);
    font-weight: bold;
}
.redemption-nomore {
    border-left: 4px solid #06c3df;
    padding-bottom: 0;
    padding-left: 10px;
}
.nowrap {
    white-space: nowrap;
}
.avg-annual-return {
  font-size: 12px;
  font-weight: 400;
  color: #111111;
  padding-bottom: 8px;
}
.daily-ytd-return {
    padding-top: calc(8px * 2);
    padding-left: calc(8px * 2);
}
.table-container :global(th:first-of-type) {
  font-family: 'Nimbus Sans Reg', sans-serif;
  font-size: 20px;
  font-weight: normal;
    font-size: 20px;
    opacity: 1;
}
.table-container {
    margin-bottom: calc(8px * 2);
}
/*stylelint-disable*/
.table :global(tr.row-0 > td:first-of-type) {
        color: #3b3b3b;
    }
.table :global(tr.row-3 > td:first-of-type) {
        color: #3b3b3b;
    }
.table :global(tr.row-4 > td:first-of-type) {
        color: #3b3b3b;
    }
/*stylelint-enable*/
`;

export default styles;